import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Conversation.scss';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

class ConversationComponent extends Component {
  componentDidMount() {
    this.scrollToBottom();
  }
  componentDidUpdate() {
    this.scrollToBottom();
  }

  setInputRef = (ref) => {
    if (!this.inputRef) {
      this.inputRef = ref;
    }
  }
  setListRef = (ref) => {
    if (!this.listRef) {
      this.listRef = ref;
    }
  }

  scrollToBottom = () => {
    if (this.listRef) {
      this.listRef.scrollTop = this.listRef.scrollHeight;
    }
  }

  handleInputKeyPress = (e) => {
    if (e.which === 13 || e.keyCode === 13) {
      const { onMessageSend } = this.props;
      const inputValue = this.inputRef.value;
      this.inputRef.value = '';
      onMessageSend(inputValue);
    }
  }

  render() {
    const { t, renderMessages } = this.props;
    const typeMessagePlaceholder = t('type_message');
    return (
      <div className="conversation">
        <div className="messages-box" ref={this.setListRef}>
          {renderMessages()}
        </div>
        <div className="input-wrapper messages-input">
          <input
            className="settings_input"
            placeholder={typeMessagePlaceholder}
            onKeyPress={this.handleInputKeyPress}
            ref={this.setInputRef}
          />
        </div>
      </div>
    );
  }
}

ConversationComponent.propTypes = {
  t: PropTypes.func.isRequired,
  renderMessages: PropTypes.func.isRequired,
  onMessageSend: PropTypes.func,
};

ConversationComponent.defaultProps = {
  onMessageSend: null,
};

export default withScopedTranslations('conversations')(ConversationComponent);
